export default {"src":"/_next/static/media/south-sudan.783ce56a.svg","height":16,"width":22,"blurWidth":0,"blurHeight":0};